import { type ReactElement } from 'react';
import { MESSAGE_SENDERS, type SapaMessageItemType } from 'types/sapa';
import SystemMessage from './components/SystemMessage';
import UserMessage from './components/UserMessage';
import { type SapaMessageItemProps } from './types';

const SapaMessageItem = ({ message }: SapaMessageItemProps): ReactElement => {
  const messageItem = message as SapaMessageItemType;
  const isSystemMessage = message.sender === MESSAGE_SENDERS.SYSTEM;
  const MessageComponent = isSystemMessage ? SystemMessage : UserMessage;
  return <MessageComponent message={messageItem} />;
};

export default SapaMessageItem;
